import React from 'react';
import * as Inovx from '@shared';
import AssetTagsBar from './AssetTagsBar';
import KnowledgeBookBar from './KnowledgeBookBar';
import KnowledgeViewEdit from './KnowledgeViewEdit';
import ViewerStore from '../stores/ViewerStore';
import FacilityStore from '../stores/FacilityStore';
import Viewer from '../viewers/viewer/Viewer';
import ViewerSidebar from './ViewerSidebar';
import LODViewer from '../viewers/viewer/LODViewer';
import AssetSetVisualizationStore from '../stores/AssetSetVisualizationStore';
import KnowledgeBookStore from '../stores/KnowledgeBookStore';

const FacilityAssetSetsBar = React.lazy(() => import('./FacilityAssetSetsBar'));
const FacilityAssetSetVisualizationBar = React.lazy(() => import('./FacilityAssetSetVisualizationBar'));
interface ViewerAppState {
    selectedFacility?: IFacilityDetail;
    isPanoViewerVisible?: boolean;
    is3DViewerVisible?: boolean;
    assetSearchbarOpen?: boolean;
    selectedKnowledgeBook?: IKnowledgeBook | null;
}

function getViewerAppState(): ViewerAppState {
    return {
        selectedFacility: FacilityStore.getSelectedFacility(),
        isPanoViewerVisible: ViewerStore.isPanoViewerVisible(),
        is3DViewerVisible: ViewerStore.is3DViewerVisible(),
        assetSearchbarOpen: FacilityStore.getAssetSearchbarOpen(),
        selectedKnowledgeBook: KnowledgeBookStore.getSelectedKnowledgeBook(),
    };
}

class ViewerApp extends React.Component<{}, ViewerAppState> {
    private _mounted = false;

    constructor(props: {}, context: any) {
        super(props, context);
        this.state = getViewerAppState();
    }

    // stable handler + guard to prevent setState on unmounted
    private _onChange = () => {
        if (!this._mounted) return;
        this.setState(getViewerAppState());
    }

    componentDidMount() {
        this._mounted = true;
        FacilityStore.addChangeListener(this._onChange);
        ViewerStore.addChangeListener(this._onChange);
        KnowledgeBookStore.addChangeListener(this._onChange);
    }

    componentDidUpdate(_previousProps: {}, previousState: ViewerAppState) {
        const previousFacilityID = previousState.selectedFacility?.ID;
        const currentFacilityID = this.state.selectedFacility?.ID;
        const left3D = previousState.is3DViewerVisible && !this.state.is3DViewerVisible;
        const entered3D = !previousState.is3DViewerVisible && this.state.is3DViewerVisible;
        const changedFacility = previousFacilityID !== currentFacilityID;
        if (left3D || entered3D || changedFacility) {
            AssetSetVisualizationStore.reset();
        }
    }

    componentWillUnmount() {
        this._mounted = false;
        FacilityStore.removeChangeListener(this._onChange);
        ViewerStore.removeChangeListener(this._onChange);
        KnowledgeBookStore.removeChangeListener(this._onChange);
        AssetSetVisualizationStore.reset();
    }

    public render() {
        const { selectedFacility, isPanoViewerVisible, is3DViewerVisible, selectedKnowledgeBook } = this.state;
        const assetSetPanelsSupported = !!isPanoViewerVisible || !!is3DViewerVisible;
        const showManageAssetSetsPanel = !!selectedFacility && assetSetPanelsSupported;
        const showDisplayVisualizationPanel = !!selectedFacility && assetSetPanelsSupported && !selectedKnowledgeBook?.ID;

        return (
            <>
                <ViewerSidebar />
                {showManageAssetSetsPanel && (
                    <React.Suspense fallback={null}>
                        <FacilityAssetSetsBar />
                    </React.Suspense>
                )}
                {showDisplayVisualizationPanel && (
                    <React.Suspense fallback={null}>
                        <FacilityAssetSetVisualizationBar />
                    </React.Suspense>
                )}
                {selectedFacility && (isPanoViewerVisible || is3DViewerVisible) && <KnowledgeBookBar />}
                {selectedFacility && (isPanoViewerVisible || is3DViewerVisible) && <KnowledgeViewEdit />}
                <div className="facility-app-container view-collapsed">
                    {isPanoViewerVisible ? (
                        <div className="Viewer"><Viewer /></div>
                    ) : is3DViewerVisible ? (
                        <div className="Viewer"><LODViewer /></div>
                    ) : null}
                </div>
            </>
        );
    }
}

export default ViewerApp;
